
import { useEffect } from 'react';
import useChatbot from './useChatbot';
import { useWebChatContext } from '../Contexts/WebChatContext';

export default function useLiveChatEvents() {
  const { directline } = useWebChatContext(); 
  const { setIsLiveChatActive } = useChatbot();

  useEffect(() => {
    if (!directline || !directline.activity$) return;

    const subscription = directline.activity$.subscribe(activity => {
     // console.log('Activity received:', activity);
      if (activity.type === 'event') {
        if (activity.name === 'liveChatStarted') {
          //console.log("Setting live chat active");
          setIsLiveChatActive(true);
        }
        if (activity.name === 'closeLiveChat') {
          setIsLiveChatActive(false);
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [directline]);
}
